import React from "react";
import { useEffect, useState } from "react";

export const PdfViwer = ({ pdfSrc, width, height }) => {
  // return (
  //   <div>
  //     <iframe
  //       title="Quote Details"
  //       src={`data:application/pdf;base64,${pdfSrc}`}
  //       style={{ width: width ? width : "90vw", height: height ? height : "80vh" }}
  //       border="0"
  //     />
  //   </div>
  // );
  const [pdfUrl, setPdfUrl] = useState("");

  useEffect(() => {
    if (pdfSrc) {
      const byteCharacters = atob(pdfSrc);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);

      return () => URL.revokeObjectURL(url); // Cleanup on unmount
    }
  }, [pdfSrc]);

  return (
    <div>
      {pdfUrl ? (
        <iframe title="Quote Details" src={pdfUrl} style={{ width: width || "90vw", height: height || "80vh" }} border="0" />
      ) : (
        <p>Loading PDF...</p>
      )}
    </div>
  );
};
